import React from 'react'
import {useSelector} from 'react-redux'
import HereMapAtom from '../../@atoms/to_content/map_h/here_map.atom'
import {RootState} from '../../store_redux'
import settingsData from '../../data/schema/settings.json'

interface HereMapComponentProps {
  ap_latitude: number | undefined
  ap_longitude: number | undefined
  // eslint-disable-next-line
  ap_position?: 'EDIT_LOCATION_SCREEN' | 'LANDING_SCREEN'
}

const HereMapsComponent: React.FC<HereMapComponentProps> = function (props) {
  const settings = useSelector((state: RootState) => state.settings)
  const {ap_latitude, ap_longitude, ap_position = 'LANDING_SCREEN'} = props
  return (
    <HereMapAtom
      lat={ap_latitude}
      lng={ap_longitude}
      api_key={settings?.mapApiKey || settingsData.mapApiKey}
      app_id={settings?.mapAppId || settingsData.mapAppId}
      ap_position={ap_position}
    />
  )
}

export default HereMapsComponent
